const registrationLink =
  'https://docs.google.com/forms/d/e/1FAIpQLSfQkgc_5KSuyycJqj_zNFuG2QAfc-0NxZlsBvlbHH1AJAbKMw/viewform?usp=sharing&ouid=113598774127325272104';

const benefits = [
  'Шість днів активного навчання за одним з трьох напрямів на кампусі УКУ',
  'Практичні заняття та інтерактивні завдання під супроводом менторів',
  'Фінальний командний проєкт',
  'Ексклюзивний мерч APPS Summer Camp',
  'Нові знайомства, командні активності та багато цікавого',
];



export default function Tickets() {
  return (
    <section
      id="tickets"
      className="
        w-full
        bg-[#0F081B]
        px-4 pb-16 pt-4
        font-['Montserrat'] text-white
        sm:px-8 sm:pb-20 sm:pt-6
        md:pb-24 md:pt-8
      "
    >
      <div className="container mx-auto flex flex-col items-center">
        {/* Заголовок */}
        <div className="mb-8 max-w-3xl text-center md:mb-10">
          <h2
            className="
              mb-4
              text-3xl font-black uppercase
              sm:text-4xl
              md:text-6xl
            "
          >
            Реєстрація
          </h2>

          <p
            className="
              text-base leading-relaxed text-white/75
              sm:text-xl
              md:text-2xl
            "
          >
            Заповнюй реєстраційну форму та приєднуйся до{' '}
            <span className="font-bold text-[#3DFF80]">
              APPS Summer Camp 2026
            </span>
            .
          </p>
        </div>

        {/* Основна картка */}
        <div
          className="
            w-full max-w-4xl
            overflow-hidden rounded-[32px]
            border-2 border-[#E150A8]
            bg-[#170D27]
          "
        >
          <div
            className="
              flex flex-col gap-8
              p-6
              sm:p-10
              md:p-12
              lg:flex-row lg:items-stretch lg:justify-between
            "
          >
            {/* Інформація */}
            <div className="flex-1">
              <h3
                className="
                  mb-5
                  text-2xl font-black text-[#E150A8]
                  sm:text-3xl
                  md:text-4xl
                "
              >
                APPS Summer Camp
              </h3>

              <ul className="flex flex-col">
                {benefits.map((benefit, index) => (
                  <li
                    key={benefit}
                    className={`
                      py-3
                      text-base leading-relaxed text-white/80
                      sm:text-lg
                      md:text-xl
                      ${
                        index !== benefits.length - 1
                          ? 'border-b border-white/10'
                          : ''
                      }
                    `}
                  >
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>

            {/* Вартість і кнопка */}
            <div
              className="
                flex w-full flex-col justify-center
                rounded-[28px]
                bg-[#0F081B]
                p-6
                sm:p-8
                lg:max-w-[300px]
              "
            >
              <p
                className="
                  text-sm font-bold uppercase
                  tracking-[0.16em]
                  text-[#E150A8]
                "
              >
                Вартість участі
              </p>

              <p
                className="
                  mt-3
                  text-4xl font-black
                  text-[#3DFF80]
                  sm:text-5xl
                "
              >
                3000 грн
              </p>

              <p className="mt-3 text-sm leading-relaxed text-white/55">
                *Кількість місць обмежена
              </p>

              <a
                href={registrationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  mt-8
                  flex w-full items-center justify-center
                  rounded-full
                  bg-[#3DFF80]
                  px-6 py-4
                  text-center
                  text-base font-extrabold
                  uppercase text-[#0F081B]
                  transition-all duration-200
                  hover:-translate-y-1
                  hover:bg-[#E150A8]
                  sm:text-lg
                "
              >
                Зареєструватися
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
